<template>
  
  <v-card
  class="mx-auto text-white mt-5 card-container"
  :color="project.bgColor"
  max-width="340"
  height="500"
>
  <v-card-title class="new-card-title">
    {{project.title}}
  </v-card-title>

  <v-card-text class="py-2 description-text-card">
      {{project.description}}
  </v-card-text>

 

  <v-card-text class="captions-card">
      <v-chip-group
      class="my-1"
      column
      show-arrows
      multiple
    >
    <v-chip
      v-for="(tech, idx) in project.technologies.split('•')"
      :key="idx"
      class="ma-1"
      size="small"
      outlined
    >
     <p class="p-chip"> {{ tech.trim() }}</p> 
  </v-chip>
</v-chip-group>
  </v-card-text>
</v-card>


</template>
  
  <script>
  export default {
    name: 'NewsCards',
    data: () => ({
     
    }),
    props: {
      project: {
        type : Object,
        required: true
      }
    },
    async mounted(){
      
    },
    methods : {
    
    }
  }
  </script>
  
  <style scoped>

  *:focus {
    outline: none;
  }

  .description-text-card{
    height: 50%;
    font-family: 'DM Sans', sans-serif !important;
    font-size: 15px;
    font-weight: 500;
    color: white  !important;
  }

  .sub-text-card{
    height: 10%;
    font-size: 16px;
  }
  .card-container{
    padding:20px;
    margin-right: 40px !important;
    border-radius: 20px;
  }
  .new-card-title{
    font-size: 30px;
    font-family: 'Poppins', sans-serif !important;
    font-weight: bolder;
  }

  .captions-card{
    height: 30%;
  }


  .v-chip {
    background-color: white !important;
    
  
  }
  .v-chip__content {
    background-color: white !important;
    
    
  }

  .p-chip{
    color:black !important;
    font-weight: bold;
  }
 

  </style>
  